import BaseService from '../Base/BaseServices'

let Base = new BaseService('DigitalTools');
const DigitalToolsServices = Base.services;

export default DigitalToolsServices;